import React from 'react'
import { List, Header } from 'semantic-ui-react'
import Countdown from "react-countdown-now"



const About = () => (
    <List divided relaxed ordered>
        <h2><font color='blue'>About QuickSave</font></h2>
        <p><b>QuickSave</b> is a <b>online marketplace</b>, made in the manner of the likes of <i>E-Bay</i>, <i>Amazon</i>, <i>Classified</i> (in Zimbabwe) which aims to serve merchants, big or small.</p>

        <h3>Features:</h3>

        <List.Item>
            <i>Messaging system</i>: <b>yes</b>
        </List.Item>

        <List.Item>
            <i>Buy button</i>: <b>yes</b>
        </List.Item>

        <List.Item>
            <i>Shopping Cart</i>: <b>no</b>
        </List.Item>

        <List.Item>
            <i>Invitations</i>: <b>yes (email)</b>
        </List.Item>
        <List.Item>
            <i>Reviews</i>: <b>yes</b>
        </List.Item>
        <List.Item>
            <i>Listing Images</i>: <b>yes</b>
        </List.Item>

    </List>
)

export default About
